import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

export interface TurnInConfirmationDialogProps {
  open: boolean;
  unselectedRecoverableCount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

export const TurnInConfirmationDialog = ({
  open,
  unselectedRecoverableCount,
  onCancel,
  onConfirm,
}: TurnInConfirmationDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      aria-labelledby="turn-in-confirmation-title"
      aria-describedby="turn-in-confirmation-description"
    >
      <DialogTitle
        id="turn-in-confirmation-title"
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <WarningIcon color="warning" />
        Confirm Turn-In
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="turn-in-confirmation-description">
          {unselectedRecoverableCount} recoverable item{unselectedRecoverableCount === 1 ? '' : 's'}{' '}
          not selected for turn-in. Do you want to continue?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="warning" variant="contained" autoFocus>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
